import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";
import PropTypes from "prop-types";

/**Este componente renderiza la lista de pasos a seguir durante el agendamiento de una cita y marca el paso actual. Este recibe como prop el pasoActivo. */
const PasosCita = ({pasoActivo, onClickStep}) => {
  const { isReady, textosSubSecciones: textos } = useObtenerSubsecciones('tienda_makemake');
  const [listaPasos, setListaPasos] = useState([]);
  const pasos = textos?.institucional?.pasos || {};

  const history = useHistory();
  useEffect(() => {
    if (isReady) {
      setListaPasos(Object.keys(pasos))
    }
  }, [isReady])
  return (
    <>
      {
        listaPasos.map((paso, index) => {
          if (index === 0) {
            return (
              <button key={paso}
                onClick={() =>onClickStep&&onClickStep(index+1) }
                className={`btn-paso mx-auto mx-lg-0 ${pasoActivo === paso ? 'numero-select' : 'numero-unselected'}`}>
                <div><p className="numero">{index + 1}</p></div>
                <p className="paso">{pasos[paso] || 'Idioma de la cita m'}</p>
              </button>
            )
          } else {
            return (
              <div  key={paso}>
                <hr className="line-horizontal" />
                <div className={`btn-paso  ${pasoActivo ===  paso ? 'numero-select' : 'numero-unselected'}`}>
                  <div><p className="numero">{index + 1}</p></div>
                  <p className="paso">{pasos[paso] || 'paso'}</p>
                </div>
              </div>
            )
          }
        })
      }
    </>
  )
}

export default PasosCita;

PasosCita.propTypes = {
  /**
   * String que indica el paso activo
   */
  pasoActivo: PropTypes.string.isRequired
}